import { openDB } from "idb";

const DB_NAME = "stocksDB";
const STORE_NAME = "stocks";

export const initStocksDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        const store = db.createObjectStore(STORE_NAME, { keyPath: "ticker" });

        store.createIndex("name", "name", { unique: false });
        store.createIndex("symbol", "symbol", { unique: false });

      }
    },
  });
};

export const saveTickersToIDB = async (tickers) => {
  const db = await initStocksDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);

  await Promise.all(
    tickers.map((item) => {
      if (item.isActive) {
        return store.put(item);
      }
      else {
        return store.delete(item.ticker);
      }
    })
  );

  await tx.done;
};

export const searchTickers = async (query) => {
  if (!query) return [];
  const lowerQuery = query.toLowerCase();

  const db = await initStocksDB();
  const tx = db.transaction("stocks", "readonly");
  const store = tx.objectStore("stocks");

  const candidates = [];

  let cursor = await store.openCursor();

  while (cursor && candidates.length < 50) {
    const t = cursor.value;
    const ticker = t.ticker.toLowerCase();
    const name = t.name.toLowerCase();
    const symbol = t.symbol.toLowerCase();

    let score = 0;

    if (ticker === lowerQuery || symbol === lowerQuery) {
      score = 1;
    }
    else if (
      ticker.startsWith(lowerQuery) ||
      name.startsWith(lowerQuery) ||
      symbol.startsWith(lowerQuery)
    ) {
      score = 2;
    }
    else if (
      ticker.includes(lowerQuery) ||
      name.includes(lowerQuery) ||
      symbol.includes(lowerQuery)
    ) {
      score = 3;
    }

    if (score > 0) {
      candidates.push({
        data: t,
        score: score,
      });
    }

    cursor = await cursor.continue();
  }

  return (
    candidates
      .sort((a, b) => {
        if (a.score !== b.score) {
          return a.score - b.score;
        }
        return a.data.ticker.localeCompare(b.data.ticker);
      })
      .slice(0, 10)
      .map((item) => ({
        ticker: item.data.ticker,
        name: item.data.name,
        symbol: item.data.symbol,
      }))
  );
};

export const getTickersCount = async () => {
  const db = await initStocksDB();
  return db.count(STORE_NAME);
};
